// src/modules/Rules/components/modals/ConfirmCreateRule.tsx
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/ui/button';
import { ModalCenter, ModalCenterRef } from '@shared/components/ui/ModalCenter';

export interface ConfirmCreateRuleRef {
  /**
   * Abre la modal de confirmación de creación sin condiciones.
   * @param onConfirm Callback que se ejecutará si el usuario acepta.
   */
  open: (onConfirm: () => void) => void;
}

export const ConfirmCreateRule = forwardRef<ConfirmCreateRuleRef>((_, ref) => {
  const { t } = useTranslation('rulesModule');
  const modalRef = useRef<ModalCenterRef>(null);
  const confirmRef = useRef<() => void>(() => {});

  useImperativeHandle(ref, () => ({
    open: (onConfirm: () => void) => {
      confirmRef.current = onConfirm;
      modalRef.current?.openModal();
    },
  }));

  const handleConfirm = () => {
    confirmRef.current();
    modalRef.current?.closeModal();
  };

  return (
    <ModalCenter ref={modalRef} title={t('modal.create.title')} type="default" width="default">
      <div className="space-y-4">
        <p className="text-sm">{t('modal.create.message')}</p>
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" size="lg" onClick={() => modalRef.current?.closeModal()}>
            {t('modal.buttons.cancel')}
          </Button>
          <Button variant="primary" size="lg" onClick={handleConfirm}>
            {t('modal.buttons.confirm')}
          </Button>
        </div>
      </div>
    </ModalCenter>
  );
});

ConfirmCreateRule.displayName = 'ConfirmCreateRule';
